// extracted by mini-css-extract-plugin
export default {"icon-24":"ListTagCard_icon-24__WrVDK"};